module.exports = __webpack_public_path__ + "static/media/BLZ.e9916025.png";